export default "__VITE_ASSET__Ds8cWR0e__"